import type { ResolvedEdit } from "@desk/core";
import { effectiveSound, isAudibleSound } from "@desk/core";

/** Player-facing lane labels for the small editor combo chip. */
const LANE_LABELS = [
  ["headline", "Headline"],
  ["look", "Look"],
  ["motion", "Motion"],
  ["sound", "Sound"],
  ["sfx", "SFX"],
  ["sticker", "Sticker"],
  ["transition", "Transition"],
] as const;

export type CreativeLaneId = (typeof LANE_LABELS)[number][0];

/** Active expressive lanes derived from resolved (not ownership). */
export function activeCreativeLanes(resolved: ResolvedEdit): CreativeLaneId[] {
  const lanes: CreativeLaneId[] = [];
  if (resolved.captions.length > 0) lanes.push("headline");
  if (resolved.look) lanes.push("look");
  if (resolved.motions.size > 0) lanes.push("motion");
  const sound = effectiveSound(resolved);
  if (sound && isAudibleSound(sound)) lanes.push("sound");
  if (resolved.sfx.length > 0) lanes.push("sfx");
  if (resolved.stickers.length > 0) lanes.push("sticker");
  if (resolved.transitions.size > 0) lanes.push("transition");
  return lanes;
}

/**
 * Concise combo label, e.g. "Headline + Look".
 * Empty when no creative lanes are active.
 */
export function creativeComboLabel(resolved: ResolvedEdit): string {
  const lanes = activeCreativeLanes(resolved);
  if (lanes.length === 0) return "";
  const byId = new Map(LANE_LABELS);
  return lanes.map((id) => byId.get(id) ?? id).join(" + ");
}
